import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {FormDefinitionFieldModel} from '../formDefinitionField.model';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from '@angular/core';
import {FormDefinitionFieldSummaryConverter} from './formDefinitionFieldSummary.converter';

@Injectable()
export class FormDefinitionFieldConverter extends HttpModelConverter<FormDefinitionFieldModel> {

    public constructor(private summaryConverter: FormDefinitionFieldSummaryConverter) {
        super();
    }

    protected createInstance(): FormDefinitionFieldModel {
        return new FormDefinitionFieldModel();
    }

    protected enrichObject(result: FormDefinitionFieldModel, src: FormDefinitionFieldModel) {
        result.summary = this.summaryConverter.convert(src.summary);
    }

}
